<template>
    <div>
        <transition appear name="loading-bar">
            <loading-bar v-show="pending" />
        </transition>

        <b-card-body>

            <no-results-found v-if="!pending && !items.length" class="mb-0" />

            <project-weather-table :items="items" />
        </b-card-body>

        <b-card-footer v-if="showPagination">
            <b-pagination
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                class="m-0"
            />
        </b-card-footer>
    </div>
</template>

<script>

    import fetchPaginatedData from "@/mixins/fetchPaginatedData";
    import ProjectWeatherTable from "@/components/projects/ProjectWeatherTable";

    export default {
        name: 'ProjectWeatherTab',
        components: {ProjectWeatherTable},
        mixins: [fetchPaginatedData],
        props: {
            projectId: {
                type: [String, Number],
                required: true,
            },
        },
        computed: {
            apiUrl() {
                return `/api/projects/${this.projectId}/weather`;
            },
        },
    };
</script>
